import { Icon, IconName } from '@ardoq/icons';
import styled from 'styled-components';
import { colors } from '@ardoq/design-tokens';

export const AlertIcon = styled(Icon).attrs({
  iconName: IconName.WARNING,
})`
  cursor: default;
  color: ${colors.red600};
`;
